import { PDFDocument } from "pdf-lib";

export async function compressPdf(file) {
  const arrayBuffer = await file.arrayBuffer();

  const pdfDoc = await PDFDocument.load(arrayBuffer, {
    updateMetadata: false,
  });

  // Re-save PDF (basic optimization)
  const pdfBytes = await pdfDoc.save({
    useObjectStreams: true,
    addDefaultPage: false,
  });

  const compressedFile = new File(
    [pdfBytes],
    file.name,
    { type: "application/pdf" }
  );

  return compressedFile;
}
